import { render } from "./BusinessType.vue?vue&type=template&id=158c7a36"
import script from "./BusinessType.vue?vue&type=script&lang=js"
export * from "./BusinessType.vue?vue&type=script&lang=js"

import "./BusinessType.vue?vue&type=style&index=0&id=158c7a36&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__